<template>
  <div :class="className" :style="{height:height,width:width}"></div>
</template>

<script>
export default {
    props:{
        className:{
            type:String,
            default:'chart'
        },
        width:{
            type:String,
            default:'100%'
        },
        height:{
            type:String,
            default:'100%'
        },
        autoResize:{
            type:Boolean,
            default:true
        },
        chartData:{
            type:Object,
            required:true
        }
    },
 data() {
    return {
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {

    initChart() {
      let chart = this.$echarts.init(this.$el);
      console.log(chart);
      chart.setOption(this.chartData);
    },
  },
}
</script>